var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentCursoricon = function SvgCommentCursoricon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6248ff",
    d: "M5 14C5 7.373 10.373 2 17 2s12 5.373 12 12-5.373 12-12 12H5Z",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 8,
    y: 5,
    fill: "#fff",
    rx: 9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6248ff",
    d: "M21.8 13.7v.6a.3.3 0 0 1-.3.3h-3.9v3.9a.3.3 0 0 1-.3.3h-.6a.3.3 0 0 1-.3-.3v-3.9h-3.9a.3.3 0 0 1-.3-.3v-.6a.3.3 0 0 1 .3-.3h3.9V9.5a.3.3 0 0 1 .3-.3h.6a.3.3 0 0 1 .3.3v3.9h3.9a.3.3 0 0 1 .3.3z"
  }))));
};
export default SvgCommentCursoricon;